// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input":"css-1eOX7bZR5u","label":"css-1NBdmMqiJW","label_text":"css-31IsnVo5kl","label__error":"css-l3mCnT40rU"};